"use client";

import { Suspense, useEffect, useRef, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { useWizardStore } from "@/store";

// Acessar /criar sem ID redireciona para /criar/<draftId>. Se o usuário já
// tem um rascunho em andamento (draftId no store), reutiliza esse ID — assim
// ele continua de onde parou. Caso contrário, gera um novo `lp_XXXX`.
function generateDraftId() {
  const alphabet = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
  let id = "";
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    const buf = new Uint32Array(10);
    window.crypto.getRandomValues(buf);
    for (let i = 0; i < 10; i++) id += alphabet[buf[i] % alphabet.length];
  } else {
    for (let i = 0; i < 10; i++) {
      id += alphabet[Math.floor(Math.random() * alphabet.length)];
    }
  }
  return `lp_${id}`;
}

function CreateRedirect() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { draftId, giftId, setDraftId } = useWizardStore();
  // Espera a hidratação do persist antes de decidir gerar/redirecionar.
  // Sem isso o primeiro render seria com draftId=null e geraria um ID novo
  // mesmo quando o store já tinha um persistido no localStorage.
  const [hydrated, setHydrated] = useState(false);
  // `useSearchParams` retorna referência nova a cada render no Next 13+ e
  // o redirect dispara setState (setDraftId) que volta a cá pelas deps —
  // sem esse ref daria loop. Só queremos redirecionar UMA VEZ por mount.
  const redirected = useRef(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (!hydrated || redirected.current) return;
    redirected.current = true;
    // Se a sessão anterior já virou pagamento (giftId setado), gera um
    // rascunho novo — o WizardContent vai resetar o store de qualquer jeito.
    const reuseExisting = draftId && !giftId;
    const id = reuseExisting ? draftId! : generateDraftId();
    if (!reuseExisting) setDraftId(id);
    const qs = searchParams.toString();
    router.replace(`/criar/${id}${qs ? `?${qs}` : ""}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hydrated]);

  // Não renderiza nada visível: o redirect pra /criar/<id> acontece no
  // useEffect logo após a hidratação do store. Mostrar uma tela "Preparando
  // rascunho…" aqui só cria a sensação de uma página intermediária entre
  // o clique (ex.: pricing card "Pagamento") e o destino real.
  return null;
}

export default function CreatePage() {
  return (
    <Suspense>
      <CreateRedirect />
    </Suspense>
  );
}
